import { GetFlashLogReports } from '../../services/types';
import { Entitlements } from './types';

export const initialState: Entitlements = {
  authorizations: null,
  loading: true,
  error: false,
};

export const mockTimeRangeInput: GetFlashLogReports = {
  startTime: '2021-04-14T15:02:30.459Z',
  endTime: '2021-04-21T14:02:30.459Z',
  limit: 20,
  skip: 0,
  batchId: '',
  sortBy: 'flashDate',
  orderBy: 'DESC',
};

export const authorizations = {
  catrecid: '***-********',
  applicationId: 'IOT',
  clientId: 'SupportUI_ac_pkce_client',
  clientType: 'USER_BASED',
  primaryPartyType: 'CAT',
  appPermissions: {
    iot: {
      bulkDeviceManagement: ['*'],
      configuration: ['*'],
      deviceDetails: ['*'],
      fileTypeConfiguration: ['*'],
      firmwareLibrary: ['*'],
      reports: ['*'],
      roleManagement: ['*'],
      standardConfigLibrary: ['*'],
      transaction: ['*'],
      userManagement: ['*'],
    },
  },
};

export const response = {
  authorization: authorizations,
};

export const dummyReduxStore = {
  login: {
    client: {
      token: '',
      authenticate: () => ({ token: '' }),
    },
    envVariables: {
      entitlementsV1BaseUrl: 'dummyUrl',
    },
  },
  flashLogRange: { mockTimeRangeInput },
};
